import { eventEmitter } from './ga';

export const unsupportedBrowserPage = () => {
  eventEmitter({
    action: 'unsupported_browser_page',
    event_category: 'unsupported_browser',
    event_label: 'Unsupported Browser Page',
  });
};

export const unsupportedBrowserOkay = () => {
  eventEmitter({
    action: 'unsupported_browser_okay',
    event_category: 'unsupported_browser',
    event_label: 'Unsupported Browser - Okay Clicked',
  });
};

export const unsupportedBrowserRedirect = (browserName: string) => {
  eventEmitter({
    action: 'unsupported_browser_redirect',
    event_category: 'unsupported_browser',
    event_label: `Unsupported Browser Redirect - ${browserName}`,
  });
};
